<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 22.9 20.2"
    aria-hidden="true"
  >
    <g>
      <g id="Ebene_1">
        <g id="Gruppe_4070">
          <g id="Ellipse_63">
            <path
              class="cls-1"
              fill="currentColor"
              d="M11.3,12.7c-3.5,0-6.4-2.8-6.4-6.4S7.8,0,11.3,0s6.4,2.8,6.4,6.3-2.8,6.4-6.4,6.4ZM11.3,2c-2.4,0-4.4,2-4.4,4.3s2,4.4,4.4,4.4,4.4-2,4.4-4.4-2-4.3-4.4-4.3Z"
            />
          </g>
          <g id="Pfad_1127">
            <path
              class="cls-1"
              fill="currentColor"
              d="M21.6,19.9c-.4,0-.7-.2-.9-.6-1.9-4.1-5.5-6.6-9.2-6.6s-7.3,2.5-9.2,6.6c-.2.5-.8.7-1.3.5-.5-.2-.7-.8-.5-1.3,2.3-4.8,6.5-7.8,11-7.8s8.8,3,11,7.8c.2.5,0,1.1-.5,1.3-.1,0-.3,0-.4,0Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
